The value of `DraftPositionProfile.seekDraftPositionId` for the requested object.
